import { useCallback, useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getNotifications } from '../api/notifications';
import { cn } from '@/lib/utils';

const POLL_INTERVAL_MS = 20_000;

export default function NotificationBell({ dark = true }: { dark?: boolean }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  const fetchCount = useCallback(async () => {
    const result = await getNotifications(1);
    if (result.data) setUnreadCount(result.data.meta.unread_count);
  }, []);

  useEffect(() => {
    fetchCount();
    const id = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [fetchCount]);

  const bellClass = dark
    ? 'text-primary-foreground hover:bg-primary-foreground/15'
    : 'text-foreground hover:bg-muted';

  return (
    <button
      type="button"
      onClick={() => navigate('/notifications')}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      className={cn(
        'relative flex h-8 w-8 items-center justify-center rounded-full transition-colors',
        bellClass
      )}
    >
      <Bell className="h-5 w-5" />
      {unreadCount > 0 && (
        <span
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground leading-none"
          aria-hidden
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
